export default "__VITE_ASSET__DXUM6IxB__"